import { Controller } from '@hotwired/stimulus';
import callApi from '../common/AjaxUtil';

export default class extends Controller {
  static targets = ['roleNameInput', 'rolePriorityInput', `roleId`, 'groupId', 'policyCheckbox', 'policySelectbox'];

  static values = {};

  modify(e) {
    e.preventDefault();
    const url = `/ajax/admin/role/${this.roleIdTarget.value}`;
    callApi(url, 'PUT', this.createRequestBody())
      .then(() => {
        window.$_callBackAndSendNotice(() => {
          location.href = `${window.$_spring.context_path}/admin/role/list`;
        }, '등급이 성공적으로 수정되었습니다.');
      })
      .catch((err) => {
        if (err.messages && Object.keys(err.messages).length === 0) {
          window.$sendAlert(err.msg);
          return;
        }
        Object.values(err.messages).forEach((msg) => window.$sendAlert(msg));
      });
  }

  create(e) {
    e.preventDefault();
    const url = `/ajax/admin/role`;
    callApi(url, 'POST', this.createRequestBody())
      .then(() => {
        window.$_callBackAndSendNotice(() => {
          location.href = `${window.$_spring.context_path}/admin/role/list`;
        }, '등급이 생성되었습니다.');
      })
      .catch((err) => {
        if (err.messages && Object.keys(err.messages).length === 0) {
          window.$sendAlert(err.msg);
          return;
        }
        Object.values(err.messages).forEach((msg) => window.$sendAlert(msg));
      });
  }

  createRequestBody() {
    const policyBoard = ['BOARD_MANAGE', 'BOARD_READ', 'BOARD_WRITE'];
    const selectboxes = Array.prototype.slice.call(this.policySelectboxTargets);
    const selectList = selectboxes
      .filter((s) => s.options[s.selectedIndex].value !== '')
      .map((s) => ({
        type: s.options[s.selectedIndex].value,
        boardId: s.getAttribute('data-board-id'),
      }));
    const unSelectList = [];
    selectboxes.forEach((s) =>
      unSelectList.push(
        ...policyBoard
          .filter((b) => b !== s.options[s.selectedIndex].value)
          .map((b) => ({
            type: b,
            boardId: s.getAttribute('data-board-id'),
          })),
      ),
    );
    const checkboxes = Array.prototype.slice.call(this.policyCheckboxTargets);
    const checkedList = checkboxes
      .filter((c) => c.checked)
      .map((c) => ({
        type: c.value,
        boardId: c.getAttribute('data-board-id'),
      }));
    const unCheckedList = checkboxes
      .filter((c) => !c.checked)
      .map((c) => ({
        type: c.value,
        boardId: c.getAttribute('data-board-id'),
      }));

    checkedList.push(...selectList);
    unCheckedList.push(...unSelectList);

    return {
      id: this.roleIdTarget.value,
      name: this.roleNameInputTarget.value,
      priority: this.rolePriorityInputTarget.value,
      groupId: this.groupIdTarget.value,
      checkedPolices: checkedList,
      unCheckedPolices: unCheckedList,
    };
  }
}
